<template>
  <div class="card">
    <div v-if="alert" class="alert">
      <Icon class="alert__icon" :icon="'bell-01'" />
    </div>
    <Icon class="icon" :icon="icon" />
    <h3>{{ label }}</h3>
    <span class="value">{{ value ?? '-' }}</span>
  </div>
</template>

<script>
import Icon from "~/components/elements/Icon.vue";
export default {
  name: "ChecklistStatCard",
  components: { Icon },
  props: {
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
    alert: {
      type: Boolean,
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.card {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #f9fafb;
  border: 1px solid #cfd0d1;
  color: #262a2e;

  .icon {
    height: 30px;
    width: 30px;
    margin-bottom: 16px;
  }

  h3 {
    line-height: 20px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    text-wrap: wrap;
    text-align: center;
  }

  .value {
    line-height: 52px;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0;
  }

  .alert {
    position: absolute;
    top: 6px;
    right: 12px;
    width: 24px;
    height: 24px;
    background-color: #ae2024;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    &__icon {
      padding: 6px;
    }
  }
}
</style>
